/* USF file - Do not modify this file since it is regularly changed. Auto modified at: 11/15/2021 3:01:23 AM*/
!(function () {
	function e(e) {
	  return "[object Function]" === Object.prototype.toString.call(e);
	}
	function t(e) {
	  return "string" == typeof e || e instanceof String;
	}
	function r(r) {
	  var n;
	  r = { config: r }.config;
	  var s = new XMLHttpRequest(),
		i = r.type || "GET",
		a =
		  "GET" === i
			? (function (r) {
				var n,
				  s,
				  i = r.data;
				if (!i) return r.url;
				if ((e(i) && (i = i()), !t(i))) {
				  var a = [];
				  for (var o in i) a.push(o + "=" + encodeURIComponent(i[o]));
				  i = a.join("&");
				}
				return (
				  (n = r.url),
				  (s = i) ? (n.includes("?") ? n + "&" + s : n + "?" + s) : n
				);
			  })(r)
			: r.url;
	  s.open(i, a, !0),
		(s.timeout = r.timeout),
		s.setRequestHeader(
		  "Content-Type",
		  r.contentType || "application/x-www-form-urlencoded"
		);
	  var o = r.error,
		l = !1,
		u = !1,
		c = {
		  abort: function () {
			(l = !0), (u = !0), s.abort(), r.abort && r.abort.apply(r, [s]);
		  },
		};
	  (s.onreadystatechange = function () {
		4 == s.readyState &&
		  (s.status >= 200 && s.status < 400
			? r.success &&
			  r.success.apply(r, [
				(function (e, t) {
				  switch (e.dataType) {
					case "json":
					  return JSON.parse(t.responseText);
					default:
					  return t.responseText;
				  }
				})(r, s),
				{
				  xhr: s,
				  redirected: (function (e, t) {
					for (var r = 0, n = t.response; r < n.length; ) {
					  var s = n[r++];
					  if ("\t" !== s && " " !== s && "\r" !== s && "\n" !== s)
						return "<" === s && -1 !== n.indexOf("<html");
					}
				  })(0, s),
				  config: r,
				},
			  ])
			: o &&
			  !l &&
			  ((l = !0), o.apply(r, [s, s.status, null, { xhr: s, config: r }])));
	  }),
		(s.onerror = function (e) {
		  o && !l && ((l = !0), o.apply(r, [s, s.status, e]));
		}),
		(s.ontimeout = function (e) {
		  o && !l && ((l = !0), o.apply(r, [s, "timeout", e]));
		}),
		(s.onabort = function (e) {
		  u || ((l = !0), (u = !0), r.abort && r.abort.apply(r, [s]));
		});
	  var f = r.data;
	  e(f) && (f = f());
	  try {
		s.send(f);
	  } catch (n) {
		o && !l && ((l = !0), o.apply(r, [s, s.status, n]));
	  }
	  return c;
	}
	var n,
	  s = function () {
		this.list = {};
	  };
	(s.prototype = {
	  add(e, t) {
		if (Array.isArray(e))
		  for (var r = e.length, n = 0; n < r; n++) this.add(e[n], t);
		else {
		  var s = this.list[e];
		  s || (this.list[e] = s = []), s.push(t);
		}
	  },
	  remove(e, t) {
		t || delete this.list[e];
		var r = this.list[e];
		r.splice(r.indexOf(t), 1);
	  },
	  raise(e, t, r) {
		if (window.usf_container || "rerender" !== e) {
		  var n = this.list[e];
		  if (n) for (var s = 0; s < n.length; s++) n[s](t, r);
		  else;
		}
	  },
	}),
	  window.usf || (window.usf = {}),
	  (usf.components = {}),
	  (usf.collectionsByUrlName = {}),
	  (usf.EventHub = s),
	  (usf.event = n = new s());
	var i = usf.settings;
	i.currencyRate = 1;
	var a,
	  o,
	  l = i.instantSearch.online,
	  u = i.search.online,
	  c = function (e) {
		if (((this.list = []), e))
		  for (var t = 0; t < e.length; t++) this.push(e[t]);
		var r = this,
		  n = !1;
		function s() {
		  if (!n) {
			var e = i.analyticsApiUrl;
			if (void 0 !== navigator.sendBeacon) {
			  var t = navigator.sendBeacon(
				e,
				JSON.stringify({ events: r.list, time: new Date() })
			  );
			  n = t;
			} else {
			  var s =
				  "events=" +
				  encodeURIComponent(JSON.stringify(r.list)) +
				  "&time=" +
				  new Date().toISOString(),
				a = new XMLHttpRequest();
			  a.open("POST", e, !1),
				a.setRequestHeader("Content-Type", "text/plain;charset=UTF-8"),
				a.send(s);
			}
		  }
		}
		window.addEventListener("beforeunload", s),
		  window.addEventListener("unload", s);
	  };
	(c.prototype = {
	  push(e) {
		"function" == typeof e && (e = e.apply(this)),
		  e.length && this[e[0]].apply(this, e.slice(1, e.length)),
		  this.list.push(e);
	  },
	  track(e, t) {
		(t.event = e),
		  (t.siteId = i.siteId),
		  (t.time = new Date()),
		  this.list.push(t);
	  },
	}),
	  (window._usfaq = new c(window._usfaq));
	var f,
	  d,
	  h,
	  p,
	  g,
	  m,
	  y = { List: 0, Box: 1, Swatch: 2 };
	function _(e) {
	  if (e && !d) {
		var t = document.createElement("div");
		(t.innerHTML = e),
		  usf_container.parentNode.insertBefore(t, usf_container),
		  (d = 1),
		  k.redirectToOriginalView();
	  }
	}
	function w(e, t, r) {
	  function s(s) {
		if (r)
		  if (f) {
			var i = f;
			(f = s), i();
		  } else f = s;
		else {
		  (a = null),
			(e.loader = !1),
			(s = JSON.parse(s)),
			n.raise("sr_dataReceived", this, s.data);
		  var o = s.data.redirect;
		  o && e.onRedirect(o),
			t && e.result && c
			  ? (e.result.items = e.result.items.concat(s.data.items))
			  : (e.result = s.data);
		  var l = s.data.facets;
		  if (((e.hasFacets = l && l.length), e.hasFacets)) {
			for (var u = !1, d = 0; d < l.length; d++) {
			  var h = l[d];
			  (h.labels.length ||
				void 0 !== h.min ||
				(h.navigationCollectionsKeepMain &&
				  h.navigationCollectionsMenu.length)) &&
				(u = !0),
				(h.displayMode = y[h.display]);
			}
			u || (e.hasFacets = !1);
		  }
		  e.itemsLoaded += s.data.items.length;
		  var p = s.data.extra;
		  if (p) {
			var v = p.collections;
			if (v) {
			  var g = (usf.collectionsByUrlName = {});
			  for (d = 0; d < v.length; d++) {
				var m = v[d];
				g[m.urlName] = m;
			  }
			}
			_(p.message);
		  }
		  document.body.classList[e.noFacets ? "add" : "remove"](
			"usf-has-no-facets"
		  ),
			e.$nextTick &&
			  e.$nextTick(() => {
				n.raise("sr_updated", this, s.data);
			  });
		}
	  }
	  if (r) f = null;
	  else if (void 0 !== f) {
		function l() {
		  s(f), (f = void 0);
		}
		return void (null === f ? (f = l) : l());
	  }
	  var u = i.search.more,
		c = "more" === u || "infinite" === u,
		d = { q: b(e.term), apiKey: i.siteId },
		h = k.locale;
	  h && (d.locale = h),
		window._usfGetProductDescription || (d.getProductDescription = 0);
	  var p = k.customerTags;
	  p && p.length && (d.customerTags = p.join(","));
	  var v,
		g,
		m = e.facetFilters,
		w = { query: d, filters: m };
	  k.onSearch(w),
		(m = w.filters) && (d.facetFilters = JSON.stringify(m)),
		c
		  ? ((v = e.itemsLoaded), (g = e.take - v))
		  : ((v = (e.page - 1) * e.itemsPerPage), (g = e.itemsPerPage)),
		(d.skip = v),
		(d.take = g),
		e.sortBy && "r" !== e.sortBy && (d.sort = e.sortBy),
		e.itemsLoaded ||
		  o === e.term ||
		  ((o = e.term),
		  e.term &&
			_usfaq.track("search", {
			  term: e.term,
			  isEmpty: e.result && !e.result.items.length,
			})),
		a && a.abort(),
		(a = usf.utils.send({
		  url: i.searchSvcUrl + "search",
		  data: d,
		  startTime: e._refreshTime,
		  success: s,
		  error: function (r, n, s) {
			403 !== n
			  ? setTimeout(() => {
				  f = void 0;
				  var r = usf.search;
				  (r._refreshTime = e._refreshTime), r.refresh(t);
				}, 3e3)
			  : _(JSON.parse(r.response).meta.description);
		  },
		}));
	}
	function b(e) {
	  for (var t = 0; t < e.length && " " === e[t]; ) t++;
	  return (
		t > 0 && (e = e.substr(t)), e.toLocaleLowerCase().replace(/[*\?]/g, "")
	  );
	}
	usf._refineTerm = b;
	var S = location.pathname.toLowerCase();
	usf.platform = {
	  name: "shopify",
	  termVar: "q",
	  isCollectionPage:
		-1 !== S.indexOf("/collections/") && -1 === S.indexOf("/products/"),
	  get collection() {
		if (g) return g;
		var e = k.collectionWithParams;
		if (e) {
		  var t = e.lastIndexOf("/");
		  -1 !== t && (e = e.substring(0, t)), (g = e);
		}
		return e;
	  },
	  set collection(e) {
		g = e;
	  },
	  get locale() {
		if (!h) {
		  var e = S,
			t = e.indexOf("/collections/");
		  -1 === t &&
			(t = e.endsWith("/search") ? e.length - 7 : e.indexOf("/pages/")),
			(h =
			  t > 0
				? e.substring(1, t).replace(/[\/\\]/g, "_")
				: Shopify.locale.toLowerCase());
		}
		return h;
	  },
	  get baseUrl() {
		if (void 0 === p) {
		  var e = S,
			t = "/" + k.locale;
		  e.startsWith(t) || (t = ""), (p = t);
		}
		return p;
	  },
	  get collectionWithParams() {
		var e = S,
		  t = k.baseUrl;
		if (e.startsWith(t + "/collections/"))
		  return decodeURIComponent(e.substring(t.length + 13));
	  },
	  get tagUrlName() {
		if (void 0 === m) {
		  var e = k.collectionWithParams;
		  if (e) {
			var t = e.lastIndexOf("/");
			m = -1 !== t ? e.substring(t + 1) : null;
		  }
		}
		return m;
	  },
	  get customerTags() {
		return _usfCustomerTags;
	  },
	  onSearch(e) {
		if ("vendors" === k.collection) {
		  var t = G.get("q");
		  t &&
			((e.query.q = ""),
			e.filters || (e.filters = {}),
			(e.filters._usf_vendor = ["vendor", [t]]));
		}
		var r = _usfCollectionId || "",
		  n = k.tagUrlName;
		n && (r += "/" + n),
		  (r || k.isCollectionPage) && (e.query.collection = r);
	  },
	  init() {
		_usfTheme.applied && (i.search.searchResultsUrl = "/search");
	  },
	  redirectToOriginalView() {
		var e = location.href;
		-1 === e.indexOf("no-usf") &&
		  (location = e + (-1 === e.indexOf("?") ? "?" : "&") + "view=no-usf");
	  },
	};
	var k = usf.platform;
	const C = "_usf_";
	var E = function (e) {
	  (this.canChangeUrl = e), (this.changed = []);
	  var t = this;
	  function r() {
		t.changed.forEach((e) => e());
	  }
	  (history.pushState = ((e) =>
		function () {
		  var t = e.apply(this, arguments);
		  return r(), t;
		})(history.pushState)),
		(history.replaceState = ((e) =>
		  function () {
			var t = e.apply(this, arguments);
			return r(), t;
		  })(history.replaceState)),
		window.addEventListener("popstate", () => {
		  r();
		});
	};
	function T(e) {
	  return (e = e.replace(/\+/g, " ")), decodeURIComponent(e);
	}
	var U = function (e) {
	  for (
		var t = e ? e.substring(1).split("&") : [], r = [], n = 0;
		n < t.length;
		n++
	  ) {
		var s = t[n].split("="),
		  i = s[1];
		if (void 0 !== i) {
		  var a,
			o = i.split(C);
		  (a = o.length > 1 ? o.map((e) => T(e)) : T(i)), r.push([T(s[0]), a]);
		}
	  }
	  this.entries = r;
	};
	U.prototype = {
	  get(e, t) {
		var r = this.entries.find((t) => t[0] === e);
		return r ? r[1] : t;
	  },
	  append(e, t) {
		this.entries.find((r) => r[0] === e && r[1] === t) ||
		  this.entries.push([e, t]);
	  },
	  set(e, t) {
		var r = this.entries.find((t) => t[0] === e);
		r ? (r[1] = t) : this.entries.push([e, t]);
	  },
	  toString() {
		var e,
		  t = this.entries
			.map(
			  (t) =>
				encodeURIComponent(t[0]) +
				"=" +
				((e = t[1]),
				Array.isArray(e)
				  ? e.map((e) => encodeURIComponent(e)).join(C)
				  : encodeURIComponent(e))
			)
			.join("&");
		return t ? "?" + t : "";
	  },
	  delete(e, t) {
		for (var r = this.entries.length - 1; r >= 0; r--) {
		  var n = this.entries[r];
		  O(e, decodeURIComponent(n[0])) &&
			((t && decodeURIComponent(n[1]) !== t) || this.entries.splice(r, 1));
		}
	  },
	};
	var P = location.search;
	function L(e, t, r, n) {
	  if (!1 !== r) {
		if (n.canChangeUrl) {
		  var s = T(location.search) !== T(e);
		  return r || s
			? ((e = location.pathname + e),
			  t || !s
				? history.replaceState(null, null, e)
				: history.pushState(null, null, e),
			  !0)
			: void 0;
		}
		e !== P && ((P = e), n.changed.forEach((e) => e()));
	  }
	}
	function O(e, r) {
	  return t(e) ? e === r : e.test(r);
	}
	function x(e, t, r) {
	  Object.keys(t).forEach((n) => {
		(function (t, r) {
		  for (var n = 0; n < e.entries; n++) {
			var s = e.entries[n];
			if (s[0] === t && s[1] === r) return !0;
		  }
		})(n, t[n]) || e[r.append ? "append" : "set"](n, t[n]);
	  });
	}
	(E.prototype = {
	  get(e, t) {
		return new U(this.getSearch()).get(e, t);
	  },
	  entries() {
		return new U(this.getSearch()).entries;
	  },
	  snapshot() {
		this._snapshot = this.entries();
	  },
	  getSearch() {
		return this.canChangeUrl ? location.search : P;
	  },
	  getChanges() {
		var e = this.entries(),
		  t = this._snapshot;
		if (!t) return e;
		var r = [];
		return (
		  e.forEach((e) => {
			t.find((t) => t[0] === e[0] && t[1] === e[1]) || r.push(e);
		  }),
		  t.forEach((t) => {
			e.find((e) => e[0] === t[0]) || r.push([t[0]]);
		  }),
		  r
		);
	  },
	  update(e, t, r) {
		var n = new U(this.getSearch());
		if ((r || (r = {}), t))
		  if (t.length) t.forEach((e) => n.delete(e));
		  else
			for (var s = n.entries.length - 1; s >= 0; s--) {
			  var i = n.entries[s],
				a = i[0];
			  if (t.hasOwnProperty(a)) {
				var o = t[a];
				i[1] === o && n.delete(a, o);
			  }
			}
		return e && x(n, e, r), L(n.toString(), r.replace, r.force, this);
	  },
	  add(e, t) {
		var r = new U(this.getSearch());
		return (
		  t || (t = {}), x(r, e, t), L(r.toString(), t.replace, t.force, this)
		);
	  },
	  remove(e) {
		var r,
		  n = new U(this.getSearch()),
		  s = arguments.length;
		if (
		  (s >= 2 && "object" == typeof (r = arguments[s - 1]) && r && s--,
		  2 === s && (l = arguments[1]))
		)
		  for (var i = 0; i < n.entries.length; i++) {
			if ((a = n.entries[i])[0] === e && a[1] === l) {
			  n.delete(e, l);
			  break;
			}
		  }
		else if (t(e))
		  for (i = 0; i < n.entries.length; i++) {
			if ((a = n.entries[i])[0] === e) {
			  n.delete(e);
			  break;
			}
		  }
		else if (e.length)
		  e.forEach((e) => {
			e && (Array.isArray(e) ? n.delete(e[0], e[1]) : n.delete(e));
		  });
		else
		  for (i = n.entries.length - 1; i >= 0; i--) {
			var a,
			  o = (a = n.entries[i])[0];
			if (e.hasOwnProperty(o)) {
			  var l = e[o];
			  a[1] === l && n.delete(o, l);
			}
		  }
		return r || (r = {}), L(n.toString(), r.replace, r.force, this);
	  },
	}),
	  (usf.Query = E);
	function I() {}
	I.prototype = {
	  get term() {
		return G.get(k.termVar, "");
	  },
	  set term(e) {
		var t = {};
		(t[k.termVar] = e),
		  G.update(t, [/uff_.*/, /usf_.*/, "page"], { force: !0 });
	  },
	  getTermQuery: (e) => k.termVar + "=" + encodeURIComponent(e),
	  get page() {
		return parseInt(G.get("page")) || 1;
	  },
	  set page(e) {
		if (e <= 1) G.remove("page");
		else {
		  var t = {};
		  (t.page = e), G.add(t);
		}
	  },
	  get take() {
		return parseInt(G.get("usf_take")) || i.search.itemsPerPage;
	  },
	  set take(e) {
		e ? ((v = {}), (v.usf_take = e), G.update(v)) : G.remove("usf_take");
	  },
	  get skip() {
		return parseInt(G.get("usf_skip"));
	  },
	  set skip(e) {
		e ? ((v = {}), (v.usf_skip = e), G.update(v)) : G.remove("usf_skip");
	  },
	  resetPagination() {
		G.remove(["usf_take", "usf_skip"]);
	  },
	  get itemsPerPage() {
		return (function (e, t) {
		  var r = parseInt(e) || t;
		  r > t && (r = t);
		  return r;
		})(G.get("usf_ipp"), i.search.itemsPerPage);
	  },
	  getPageUrl(e) {
		if (this.p === this.page) return "javascript:void(0)";
		var t = new URL(window.location.href),
		  r = t.searchParams;
		return !e || e <= 1 ? r.delete("page") : r.set("page", e), t.toString();
	  },
	  get facetFilters() {
		var e,
		  t = {};
		return (
		  G.entries().forEach((r) => {
			var n = r[0];
			if (n.startsWith("uff_")) {
			  var s = "uff_".length,
				i = n.indexOf("_", s),
				a = n.substring(s, i);
			  a = parseInt(a, 36);
			  var o = n.substr(i + 1),
				l = r[1];
			  Array.isArray(l) || (l = [l]), (t[a] = [o, l]), (e = !0);
			}
		  }),
		  e ? t : null
		);
	  },
	  set facetFilters(e) {
		if (Object.keys(e).length) {
		  var t,
			r = {};
		  for (var n in e) {
			var s = e[n];
			r["uff_" + ((t = n), parseInt(t).toString(36)) + "_" + s[0]] = s[1];
		  }
		  G.update(r, [/uff_.*/, "page"]);
		} else this.removeAllFacetFilters();
	  },
	  get view() {
		return G.get("usf_view", "grid");
	  },
	  set view(e) {
		if (e) {
		  var t = {};
		  (t.usf_view = e), G.add(t);
		} else G.remove("usf_view");
	  },
	  isViewChanged: (e) => 1 !== e.length || "usf_view" !== e[0][0],
	  get sort() {
		var e = G.get("usf_sort");
		if (e) return e;
		var t = i.search.sortFields;
		return t ? t[0] : "";
	  },
	  set sort(e) {
		if (e) {
		  var t = {};
		  (t.usf_sort = e), G.add(t);
		} else G.remove("usf_sort");
	  },
	  removeAllFacetFilters() {
		G.remove([/uff_.*/, "page"]);
	  },
	};
	var R = new I();
	usf.queryRewriter = R;
	var A = function (e) {
	  if (((this.plugins = []), e))
		for (var t = 0; t < e.length; t++) this.push(e[t]);
	};
	function F(e, t, r) {
	  var n, s, i;
	  for (s = document.getElementsByTagName("link"), i = 0; i < s.length; i++)
		if (s[i].href.endsWith(e)) return !1;
	  return (
		(n = document.createElement("link")).setAttribute("rel", "stylesheet"),
		n.setAttribute("type", "text/css"),
		n.setAttribute("href", e),
		t && (n.onload = t),
		r && (n.onerror = r),
		document.head.appendChild(n),
		!0
	  );
	}
	function N(e, t, r, n) {
	  var s, i, a;
	  for (
		i = document.getElementsByTagName("script"), a = 0;
		a < i.length;
		a++
	  ) {
		var o = i[a].src;
		if (o && o.endsWith(e)) return !1;
	  }
	  return (
		(s = document.createElement("script")).setAttribute(
		  "type",
		  "text/javascript"
		),
		s.setAttribute("src", e),
		(s.async = !0),
		n &&
		  Object.keys(n).forEach(function (e) {
			s.setAttribute(e, n[e]);
		  }),
		t && (s.onload = t),
		r && (s.onerror = r),
		document.head.appendChild(s),
		!0
	  );
	}
	function q(e, t, r, n) {
	  for (var s = 0, i = 0, a = 0; a < t.length; a++) {
		var o,
		  l = t[a];
		n ? (0, (o = N)) : (o = F),
		  l.startsWith("http") || l.startsWith("/") || (l = e + l),
		  o(l, function () {
			++s === i && r();
		  }) && i++;
	  }
	  i === s && r();
	}
	function j(e, t) {
	  for (; e; ) {
		if (!e || e === document.body || e.value == "") return;
		if ((e = e.parentNode) && e.classList.contains(t)) return e;
	  }
	}
	function B(e, t, r, n) {
	  if (!e) throw new Error("Element must be set.");
	  if (e.length) for (var s = 0; s < e.length; s++) B(e[s], t, r, n);
	  else if ((e._r_events || (e._r_events = {}), "string" == typeof t))
		r &&
		  (n || (n = {}),
		  (function (e, t, r, n) {
			var s,
			  i = e._r_events[t];
			i || (e._r_events[t] = i = []);
			(s = function (t) {
			  return r.call(e, t);
			}),
			  e.addEventListener(t, s, n),
			  (i[i.length] = { handler: r, browserHandler: s, options: n });
		  })(e, t, r, n));
	  else
		for (var i in t) {
		  B(e, i, t[i], r);
		}
	}
	function M(e) {
	  "loading" === document.readyState
		? document.addEventListener("DOMContentLoaded", e)
		: e();
	}
	function W(e) {
	  J && ((J = []), delete J), n.raise("is_show", e);
	}
	function W1(e) {
	  J && ((J = []), delete J), n.raise("is_hide", e);
	}
	function D(e, t) {
	  K(function () {
		!(function (e, t) {
		  // if (j(e, "usf-sr-inputbox") && usf.platform.collection) return;
		  // (t || e.value) && n.raise("is_show", e);
		  e && n.raise("is_show", e);
		})(e, t);
	  });
	}
	(A.prototype = {
	  push(e) {
		this.plugins.push(e);
	  },
	  invoke(e, t) {
		return (function e(t, r, n, s) {
		  if (!(r >= t.length)) {
			var i = t[r],
			  a = i[n];
			if (a) {
			  var o = s.slice(0, s.length);
			  return (
				o.push(function () {
				  if (r < t.length - 1) return e(t, r + 1, n, s);
				}),
				a.apply(i, o)
			  );
			}
			return e(t, r + 1, n, s);
		  }
		})(this.plugins, 0, e, t);
	  },
	  has(e) {
		for (var t = this.plugins, r = 0; r < t.length; r++)
		  if (t[r][e]) return !0;
	  },
	}),
	  (usf.plugins = new A(usf.plugins)); /* Begin plugin code */
  
	/* End plugin code */
	(usf.utils = {
	  on: B,
	  off: function (e, t, r) {
		if (e._r_events && t) {
		  var n = null,
			s = e._r_events[t] || [];
		  if (void 0 !== r) {
			for (var i = 0, a = s.length; i < a; i++)
			  if (s[i].handler === r) {
				n = s[i].browserHandler;
				break;
			  }
			e.removeEventListener(t, n), s.splice(i, 1);
		  } else if ("string" == typeof t) {
			for (i = 0, a = s.length; i < a; i++)
			  (n = s[i].browserHandler), e.removeEventListener(t, n);
			delete e._r_events[t];
		  } else
			for (var o in t) {
			  for (
				r = t[o], i = 0, a = (s = e._r_events[o] || []).length;
				i < a;
				i++
			  )
				if (s[i].handler === r) {
				  n = s[i].browserHandler;
				  break;
				}
			  e.removeEventListener(o, n), s.splice(i, 1);
			}
		}
	  },
	  closest: j,
	  loadJsFile: N,
	  loadFiles: q,
	  ready: M,
	  installSearchInput: z,
	  hideInstantSearch: W1,
	  loadAndShowInstantSearch: D,
	  stopEvent: (e, t) =>
		!!e &&
		(e.preventDefault && e.preventDefault(),
		t || (e.stopPropagation && e.stopPropagation(), (e.cancelBubble = !0)),
		(e.returnValue = !1),
		!1),
	  send(e, t) {
		var n = e.startTime || new Date().getTime();
		if (!e._errorModified) {
		  var s = 6e3,
			i = e.error;
		  (e.timeout = s),
			(e._errorModified = 1),
			(e.error = function (r) {
			  var a;
			  if (new Date().getTime() - n >= s)
				return (
				  (e.url = (a = e.url).includes("fallback")
					? a
					: a.replace(/svc-(\d+)-/, "svc-$1-fallback-")),
				  delete e.timeout,
				  setTimeout(() => usf.utils.send.apply(this, [e, t]), 200),
				  void (s = 1500)
				);
			  i.apply(this, arguments);
			});
		}
		if (!t) {
		  var a = usf.plugins.invoke("send", [e]);
		  if (void 0 !== a) return a;
		}
		return r(e);
	  },
	}),
	  (usf.fetch = w),
	  (usf.query = new E(i.search.canChangeUrl));
	var H,
	  V,
	  J,
	  G = usf.query;
	function $(e) {
	  if (!e.target._usf_no_popup) {
		var t = e.target;
		t.value ? D(t) : W(t);
	  }
	}
	function z(e, t) {
	  if (e && (l || u)) {
		var r = e.parentNode;
		if (!r.classList.contains("usf-sr-inputbox")) {
		  var n = e.cloneNode(!0);
		  r.replaceChild(n, e), (e = n);
		}
		for (; "FORM" !== r.tagName; )
		  if ((r = r.parentNode) === document.body) {
			r = null;
			break;
		  }
		if (
		  ((H = k.baseUrl + i.search.searchResultsUrl),
		  r &&
			u &&
			((r.action = H),
			(r.onsubmit = function (t) {
			  var r = window.usf_container;
			  return (
				location.pathname.includes(H) || (r && j(e, "usf-sr-inputbox"))
				  ? ((R.term = e.value), r && r.click(), W(e))
				  : (location =
					  H + "?" + k.termVar + "=" + encodeURIComponent(e.value)),
				usf.utils.stopEvent(t)
			  );
			})),
		  (e._usf_no_popup = t),
		  e.setAttribute("autocomplete", "off"),
		  l)
		) {
		  var s = t
			? null
			: function (e) {
				if (usf.isMobile) return D(e.target, !0), usf.utils.stopEvent(e);
				D(e.target);
			  };
		  B(e, {
			input: $,
			keydown: function (e) {
			  13 === e.keyCode &&
				(usf.utils.stopEvent(e),
				r && u
				  ? r.onsubmit()
				  : (location =
					  H +
					  "?" +
					  k.termVar +
					  "=" +
					  encodeURIComponent(e.target.value)));
			},
			click: s,
			focus: s,
		  });
		}
	  }
	}
	function K(e) {
	  if (2 !== V)
		if (1 !== V) {
		  var t;
		  V = 1;
		  var r = [
			  (t = _usfTheme.assetUrl.replace("usf-boot.js", "{0}")).replace(
				"{0}",
				"usf.js?v=3"
			  ),
			],
			s = [t.replace("{0}", "usf.css?v=2")];
		  n.raise("preinit"),
			e ||
			  w(
				{
				  _refreshTime: new Date().getTime(),
				  term: R.term,
				  itemsLoaded: 0,
				  itemsPerPage: R.itemsPerPage,
				  page: R.page,
				  take: R.take,
				  facetFilters: R.facetFilters,
				  sortBy: R.sort,
				},
				!1,
				!0
			  ),
			q(
			  t,
			  r,
			  function () {
				(V = 2),
				  J && (J.forEach((e) => e()), delete J),
				  (H = k.baseUrl + i.search.searchResultsUrl),
				  e && e(),
				  M(function () {
					n.raise("init");
					var e = document.body.classList;
					document.body.addEventListener("keyup", function (t) {
					  9 == t.keyCode && e.add("usf-wc");
					}),
					  document.addEventListener("click", function (t) {
						e.remove("usf-wc");
					  });
				  });
			  },
			  1
			),
			q(t, s, function () {}, 0);
		} else e && (J || (J = []), J.push(e));
	  else e && e();
	}
	if (i.online) {
	  k.init();
	  var Q = location.pathname,
		X = (usf._canLoadContainer =
		  (k.isCollectionPage
			? i.collections.online
			: -1 !== Q.indexOf(i.search.searchResultsUrl) && i.search.online) ||
		  window._usfHasContainer);
	  X && K(),
		M(function () {
		  var e = document.body.classList;
		  (usf.isMobile = document.body.clientWidth < i.mobileBreakpoint) &&
			e.add("usf-mobile"),
			X &&
			  window.usf_container &&
			  (e.add("usf-has-container"),
			  k.isCollectionPage && e.add("usf-collections-page"),
			  e.add(i.filters.horz ? "usf-horz-layout" : "usf-vert-layout")),
			l &&
			  i.instantSearch.searchBoxSelector.split(",").forEach((e) => {
				for (
				  var t = document.body.querySelectorAll(e), r = 0;
				  r < t.length;
				  r++
				)
				  z(t[r]);
			  });
		});
	}
  })();
  